import { createContext, useContext, useMemo, useSyncExternalStore, type PropsWithChildren } from 'react';

import { authStore } from '../auth/authStore';
import { parseIsAdmin } from '../auth/parseIsAdmin';

type FeatureFlags = {
  isStructurelyAdmin: boolean;
};

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined);

export const FeatureFlagsProvider = ({ children }: PropsWithChildren) => {
  const auth = useSyncExternalStore(authStore.subscribe, authStore.getAuth);
  const isStructurelyAdmin = parseIsAdmin(auth?.token);
  const value = useMemo<FeatureFlags>(() => ({ isStructurelyAdmin }), [isStructurelyAdmin]);

  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlagsContext = (): FeatureFlags => {
  const value = useContext(FeatureFlagsContext);
  if (value === undefined) {
    throw new Error('useFeatureFlagsContext must be used within a FeatureFlagsProvider.');
  }

  return value;
};
